export default __webpack_public_path__ + "static/media/Menu.99c3ef0e.svg";